// 律师搜索弹框状态
export const SEARCHMOBLESHOW = 'SEARCHMOBLESHOW';

// 获取用户基本信息
export const ACTION_USERINFO = 'ACTION_USERINFO';

// 更改getPhoneToken中的token
export const CHANGE_TOKEN_PHONE = 'CHANGE_TOKEN_PHONE';

// 获取律师基本信息
export const ACTION_LAWYER_USERINFO = 'ACTION_LAWYER_USERINFO';

// 更改userInfo里面的用户头像
export const ACTION_AVATAR = 'ACTION_AVATAR';
